var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKlarna = function SvgKlarna(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.967,
    y: 1.2,
    width: 25.6,
    height: 25.6,
    rx: 12.8,
    fill: "#FFB3C7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.967,
    y: 1.2,
    width: 25.6,
    height: 25.6,
    rx: 12.8,
    stroke: "#F5F5F5",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.651 8.467v11.11H7.1V8.468h2.551Zm6.367 0a8.84 8.84 0 0 1-2.453 6.149l-.154.157 3.524 4.805h-3.15l-3.829-5.222.989-.74a6.376 6.376 0 0 0 2.576-4.958l.002-.191h2.495Zm3.026 8.333a1.389 1.389 0 1 1 0 2.777 1.389 1.389 0 0 1 0-2.777Z",
    fill: "#000"
  })));
};
export default SvgKlarna;